import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      "x-large": "",
      color: "success",
      href: "mailto:hi@andromeda.technology",
      style: {"color":"white"},
      block: "",
      class: "pa-16"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, {
          "x-large": "",
          class: "pr-2"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("mdi-mail", -1)
          ])),
          _: 1,
          __: [0]
        }),
        _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Get in touch", -1))
      ]),
      _: 1,
      __: [1]
    })
  ]))
}